module.exports = __webpack_public_path__ + "fonts/DINRoundPro-Bold.ttf?0cc1dcec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINRoundPro-Bold.ttf
// module id = 848
// module chunks = 0 1 2 3 4 5